import { render, staticRenderFns } from "./ListJewelsPreview.vue?vue&type=template&id=2040b4a8&scoped=true&"
import script from "./ListJewelsPreview.vue?vue&type=script&lang=js&"
export * from "./ListJewelsPreview.vue?vue&type=script&lang=js&"
import style0 from "./ListJewelsPreview.vue?vue&type=style&index=0&id=2040b4a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2040b4a8",
  null
  
)

export default component.exports